export default __webpack_public_path__ + "static/and-logo-2-9fb323dd4468f02bf8f4961f69de1ee9.webp";